import { useState, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { manageInternalPortalEvent } from '../../actions/saa-internal-portal-actions';
import { isValidArray } from '../../../global/helpers/global-helpers';


function AppAdminSandboxComponent({
  // Action
  manageInternalPortalEvent,
  //Redux
  saaIntPortReduxData,
}) {

  
  const [totalFound, setTotalFound] = useState(0)
  const [fixedInstancesArray, setFixedInstancesArray] = useState([])
  // const [focusOn, setFocusOn] = useState(null)
  // const [displayErrorMessage, setDisplayErrorMessage] = useState("")

  const runFunction = () => {
    const ipMetadata = {
      userEventAction: "get-int-port-data"
    }
    manageInternalPortalEvent(ipMetadata)
  }

  useEffect(() => {
    if (saaIntPortReduxData) {
      const { processedEvent, retrievedData, count, savedSuccessfully, 
        // processedDsr, errorMessage 
      } = saaIntPortReduxData || {}

      switch (processedEvent) {
        case ("get-int-port-data"): {
          setFixedInstancesArray([...retrievedData])
          setTotalFound(count)
          break;
        }
        case ("int-port-run-fix"): {
          const { fixedId, updatedQuillFormat } = saaIntPortReduxData || {}

          fixedId && setFixedInstancesArray(prevState => [...prevState, { fixedId, updatedQuillFormat }])
          break;
        }
        case ("int-port-save-fix"): {
  
          if (savedSuccessfully) {
            // const updatedArray = fixedInstancesArray.filter(item => !processedDsr.includes(item.dsrId));

            // const spreadedArray = [...updatedArray]
            // setTotalFound(spreadedArray?.length || 0)
            setTotalFound(0)
            setFixedInstancesArray([])
          } 
          // else if (errorMessage) {
          //   setFocusOn(processedDsr)
          //   setDisplayErrorMessage(errorMessage)
          // }

          break;
        }
        default: {
          break;
        }
      }

    }
  }, [saaIntPortReduxData])

  // const runFix = (dsrId) => {
  //   const ipMetadata = {
  //     userEventAction: "int-port-run-fix",
  //     payload: {
  //       dsrId
  //     }
  //   }
  //   manageInternalPortalEvent(ipMetadata)
  // }

  const saveFix = (payload) => {
    const ipMetadata = {
      userEventAction: "int-port-save-fix",
      payload
    }
    manageInternalPortalEvent(ipMetadata)
  }

  const renderData = () => {

    if (isValidArray(fixedInstancesArray)) {
      const displayedData = fixedInstancesArray?.map(userId => {
        return (
          <Box key={userId} my='1em' bg='gray.100' rounded='0.5em' p='0.5em'>
            {/* <Box mb='0.2em' color='brand.500' fontWeight='600' fontSize='0.7em' letterSpacing={'1px'} textTransform={'uppercase'} >DSR ID</Box> */}
            {userId}
            
            {/* {displayErrorMessage && focusOn === userId && <Box>{displayErrorMessage}</Box>} */}
          </Box>
        )
       

      })

      return <>
             <Box mt='2em'>
              <LaunchdeckButton bg='brand.500' color='white' px='2em' onClick={() => saveFix({unmatchedUserIds: fixedInstancesArray})} label='Migrate' />
            </Box>
      {displayedData}

      </>;
    } else return null
  }

  const renderTotalFound = () => {
    if (totalFound >= 0) {
return (
      <Box>{totalFound || 0} entries found</Box>
    )
    } else return null
    
  }

  return (<Box>


    <Flex gap='2em' justify='flex-start' align='flex-end'>
      <LaunchdeckButton bg='brandGreen.500' color='white' px='2em' onClick={() => runFunction()} label='Run Query' />
      {renderTotalFound()}
    </Flex>



    {renderData()}
  </Box>
  );

};




function mapStateToProps(state) {
  return {
    saaIntPortReduxData: state.saaIntPortRedux.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageInternalPortalEvent
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppAdminSandboxComponent));